import 'bootstrap/dist/css/bootstrap.css';
import '@fortawesome/fontawesome-free/css/fontawesome.min.css';
import '@fortawesome/fontawesome-free/css/solid.min.css';
import '@fortawesome/fontawesome-free/css/regular.min.css';
import 'jquery/dist/jquery'
import 'popper.js'
import 'bootstrap/dist/js/bootstrap'

import React from 'react';
import ReactDOM from 'react-dom';
import 'toastr/build/toastr.css';
import '../node_modules/antd/dist/antd.css';
import './assets/css/custom-new.css';
import SiteSuptErrorBoundary from './components/SiteSuptErrorBoundary';

import App from './views/app';

ReactDOM.render(<SiteSuptErrorBoundary><App /></SiteSuptErrorBoundary>, document.getElementById('root'));

